import script from "./Bvn.vue?vue&type=script&setup=true&lang=js"
export * from "./Bvn.vue?vue&type=script&setup=true&lang=js"

import "./Bvn.vue?vue&type=style&index=0&id=d583ffba&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d583ffba"]])

export default __exports__